import { render } from "./SignupOTPVerification.vue?vue&type=template&id=1eef1b74&scoped=true"
import script from "./SignupOTPVerification.vue?vue&type=script&lang=js"
export * from "./SignupOTPVerification.vue?vue&type=script&lang=js"

import "./SignupOTPVerification.vue?vue&type=style&index=0&id=1eef1b74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eef1b74"]])

export default __exports__